import { CheckCircle2 } from 'lucide-react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/Button';
import { useExam } from '../context/ExamContext';
import { questions, totalDurationMinutes } from '../utils/examData';

export function InstructionsPage() {
  const { state, completeWorkflowStep } = useExam();
  const navigate = useNavigate();
  const [acknowledged, setAcknowledged] = useState(false);
  const items = [
    'Keep your face visible and remain seated during the mock exam.',
    'The platform logs browser events for review instead of trying to hard-block your device.',
    'AI signals are probabilistic and should be interpreted by a reviewer.',
    'Dual-camera pairing is optional but recommended for realistic practice.',
    'Keep the phone behind or beside the workspace so it captures you, the desk, and surroundings.',
    'Use a quiet, well-lit environment with a stable internet connection and close unnecessary applications.',
    'AI signals are probabilistic and reviewed by a human. Browser monitoring is not operating-system lockdown.'
  ];
  return (
    <section className="mx-auto max-w-4xl px-4 py-12">
      {state.candidate?.mode === 'public-demo' ? <p className="mb-2 text-sm font-semibold uppercase text-neon-blue">Prototype Demo</p> : null}
      <h1 className="text-3xl font-bold">Exam Instructions</h1>
      <div className="mt-5 glass grid gap-3 rounded-md p-5 sm:grid-cols-2"><p>Candidate: <strong>{state.candidate?.name}</strong></p><p>Exam: <strong>ExamSphere Mock Assessment</strong></p><p>Code: <strong>{state.candidate?.examCode}</strong></p><p>Duration: <strong>{totalDurationMinutes} minutes</strong></p><p>Questions: <strong>{questions.length}</strong></p><p>Cameras: <strong>Laptop required, phone recommended</strong></p></div>
      <ol className="mt-5 grid grid-cols-5 gap-2 text-center text-xs"><li className="text-emerald-400">Login</li><li className="font-bold text-neon-blue">Instructions</li><li>Permissions</li><li>Camera Setup</li><li>Exam</li></ol>
      <div className="mt-6 space-y-3">
        {items.map((item) => (
          <div key={item} className="flex gap-3 rounded-md border border-slate-200 bg-white p-4 dark:border-slate-800 dark:bg-slate-900">
            <CheckCircle2 className="mt-0.5 h-5 w-5 flex-none text-emerald-500" />
            <p>{item}</p>
          </div>
        ))}
      </div>
      <label className="mt-6 flex items-start gap-3"><input type="checkbox" checked={acknowledged} onChange={(event) => setAcknowledged(event.target.checked)} className="mt-1" /><span>I have read and acknowledge the examination instructions.</span></label>
      <Button className="mt-6" disabled={!acknowledged} onClick={() => { completeWorkflowStep('instructionsAcknowledged'); navigate('/permissions'); }}>Run Permission Check</Button>
    </section>
  );
}
